export default __webpack_public_path__ + "static/media/webgl.763d4bd1.png";